import { format } from 'date-fns';
import { BASE_URL } from '../../services/api';
import { useNavigate } from 'react-router-dom';
import DOMPurify from 'dompurify';

export default function ArticleCard({ data }) {
    const navigation = useNavigate();
    const sanitizedContent = DOMPurify.sanitize(data.description, {
        ALLOWED_TAGS: ['ol', 'ul', 'li', 'p', 'strong', 'em', 'a', 'b', 'i', 'u'],
    });

    const handleNavigation = () => {
        if (data?.categories[0]?.type === 'NEWS') {
            navigation(`/berita/${data?.slug}`);
        } else if (data?.categories[0]?.type === 'ARTICLE') {
            navigation(`/artikel/${data?.slug}`);
        }
    };

    return (
        <div className="flex flex-col items-start overflow-hidden shadow-sm rounded-md">
            <a href="#" onClick={() => handleNavigation()} className="block w-full transition duration-200 ease-out transform hover:scale-110 bg-surface-3">
                <img alt={data.title} className="object-cover w-full shadow-sm h-56" src={`${BASE_URL}${data?.photoUrls[0]}`}/>
            </a>
            <div className="w-full relative flex flex-col items-start px-6 bg-white border border-t-0 border-line pt-7 pb-5 rounded-b-md">
                <div className="bg-primary absolute top-0 -mt-3 flex items-center px-3 py-1.5 leading-none w-auto rounded-full text-xs font-medium uppercase text-white">
                    <span>{data.categories[0]?.name}</span>
                </div>
                <h2 className="text-xl font-bold md:text-2xl cursor-pointer title-paragraph-break" onClick={() => handleNavigation()}>{data.title}</h2>
                {/* <p className="mt-2 text-sm text-ink-500 content-paragraph-break" dangerouslySetInnerHTML={{ __html: sanitizedContent }}></p> */}
                <div className='w-full flex text-xs pt-5 gap-2'>
                    <span className='truncate'>{format(data?.createdAt, 'LLL ii, yyyy')}, {data.author}</span>
                </div>
            </div>
        </div>
    );
}
